import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-regular-svg-icons';
import { faStar as faStarFill } from '@fortawesome/free-solid-svg-icons';
import "./index.scss";
import { Button, Spinner } from "reactstrap";
import ReactTooltip from 'react-tooltip';

const FileItem = ({ className, data, handleSelectedDoc, selectedFileId, handleFavUnfavDoc, selectedIconId, fileStatus, __editDocument,_label }) => {
	const _handleSelectedDoc = (id) => {
		handleSelectedDoc(id);
	};
	const [favourite, setFavourite] = useState(false)
	const _handleFavUnfavDoc = (fav, id) => {
		if (!(fileStatus === 'true')) {
			handleFavUnfavDoc(fav, id);
			setFavourite(!favourite);
		}
	};

	// function differentiates between a single and double click, (case 1 = single, case 2 = double)
	
	const handleClick = (e) => {
		if(_label != "Archived"){
		switch (e.detail) {
			case 1:
				_handleSelectedDoc(data._id);
				break;
			case 2:
				__editDocument()
				break;
		}
		}
	};




	return (
		<>
			<div onClick={handleClick}
				className={`file-item d-inline-flex flex-column  ${className} ${data._id === selectedFileId ? `active` : ``}`}>
				<div className="head text-center" >
					<div className="icon">
						<img className="img-fluid" src={require(`../../../../assets/img/icons/${data?.file_type && data?.file_type?.toLowerCase() !== 'pdf' ? 'image' : 'pdf'}.svg`)} alt="File" />
					</div>
					<span data-tip={data.name}>{data.name}</span>
				</div>
				<div className="foot d-flex mt-auto">
					<label>
						<span>{data.size}</span>
					</label>
					<Button color="link" className={`ms-auto ${data.favorite ? 'active' : ''}`} >
						{!(selectedIconId === data._id) && <FontAwesomeIcon data-toggle="tooltip" data-placement="top" title={data.favorite ? 'Click to Mark as NonPriority' : !fileStatus ? 'Click to Mark as Priority' : ""} onClick={() => _handleFavUnfavDoc(data.favorite, data._id)} icon={data.favorite ? faStarFill : faStar} />}
						{selectedIconId === data._id && <span className="load-icon">
							<Spinner color="primary" />
						</span>}
					</Button>
				</div>
				<div className="head">
					<span data-tip={data?.type?.name} >{data?.type?.name}</span>
				</div>
				<ReactTooltip />
			</div>
		</>
	);
}
export default FileItem;